import { render, staticRenderFns } from "./productListComponent.vue?vue&type=template&id=8640b97a&scoped=true&"
import script from "./productListComponent.vue?vue&type=script&lang=js&"
export * from "./productListComponent.vue?vue&type=script&lang=js&"
import style0 from "./productListComponent.vue?vue&type=style&index=0&id=8640b97a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8640b97a",
  null
  
)

export default component.exports